export default __webpack_public_path__ + "static/media/2.b1fa0566.png";